import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import gql from 'graphql-tag';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

/** Account entity representing the account details of a user */
export type Account = {
  __typename?: 'Account';
  /** Unique identifier for the banking information */
  bankingInfoId: Scalars['Int']['output'];
  /** List of bank account types for the user */
  bankingType: Array<Scalars['String']['output']>;
  /** Unique identifier for the personal information */
  personalInfoId: Scalars['Int']['output'];
};

/** Input model for the account details of the user */
export type AccountInput = {
  /** List of bank account types for the user */
  bankingType: Array<Scalars['String']['input']>;
};

/** Input model for the application details */
export type ApplicationInput = {
  /** Type of flow for the application process */
  flowtype: Scalars['String']['input'];
  /** Source from which the application was submitted */
  source: Scalars['String']['input'];
};

/** Entity representing the consent text info itself */
export type ConsentTextInfo = {
  __typename?: 'ConsentTextInfo';
  /** Text of the consent */
  consenttext: Scalars['String']['output'];
  /** Unique identifier for the consent text */
  consenttextid: Scalars['Int']['output'];
  /** Type of consent */
  consenttype: Scalars['String']['output'];
  /** Version of the consent text */
  consentversion: Scalars['String']['output'];
};

/** Input model for creating an abandon prequalified email */
export type CreateAbandonEmailInput = {
  /** Email address of the user */
  email: Scalars['String']['input'];
  /** First name of the user */
  firstName?: Scalars['String']['input'];
  /** Last name of the user */
  lastName?: Scalars['String']['input'];
  /** Mobile phone number of the user */
  mobilePhone?: Scalars['String']['input'];
};

/** Input model for creating account information of the user */
export type CreateAccountInput = {
  /** List of bank account types for the user */
  bankingType: Array<Scalars['String']['input']>;
  /** Unique identifier for the personal information */
  personalInfoId: Scalars['Int']['input'];
};

/** Model representing the required properties for the createApplicationCaps mutation */
export type CreateApplicationCapsInput = {
  /** Approval number for the dealer */
  approvalnumber: Scalars['String']['input'];
  /** Unique identifier for a dealer */
  dealerid: Scalars['String']['input'];
  /** Display order for the dealer */
  displayorder: Scalars['Int']['input'];
  /** Distance between the dealer and the customer */
  distance: Scalars['String']['input'];
  /** Value representing how well the dealer was matched to the application */
  score: Scalars['String']['input'];
};

/** Model representing the required properties for the 'createApplication' mutation */
export type CreateApplicationInput = {
  /** Type of flow for the application process */
  flowtype: Scalars['String']['input'];
  /** Source from which the application was submitted */
  source: Scalars['String']['input'];
};

/** Model representing the required properties for the createIncome mutation */
export type CreateIncomeInput = {
  /** Bi-weekly pay of the user */
  biWeeklyPay: Scalars['String']['input'];
  /** Name of the employer */
  employerName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the employer */
  employerPhone?: InputMaybe<Scalars['String']['input']>;
  /** Order of employments for the user */
  employmentOrder: Scalars['Int']['input'];
  /** Hire date of the user */
  hireDate: Scalars['String']['input'];
  /** Type of income */
  incomeType: Scalars['String']['input'];
  /** Unique identifier for the personal information */
  personalInfoId: Scalars['Int']['input'];
};

/** Input model for creating personal information of the user */
export type CreatePersonalInfoInput = {
  /** Application details associated to the personal information */
  application: CreateApplicationInput;
  /** Date of birth of the user */
  dateOfBirth: Scalars['String']['input'];
  /** Currently not being used */
  driver?: InputMaybe<Scalars['Int']['input']>;
  /** Email address of the user */
  email: Scalars['String']['input'];
  /** First name of the user */
  firstName: Scalars['String']['input'];
  /** Last name of the user */
  lastName: Scalars['String']['input'];
  /** Phone number of the user */
  phone: Scalars['String']['input'];
  /** Unique ID corresponding to the user's social security number data */
  ssnid?: InputMaybe<Scalars['Int']['input']>;
};

/** Input model for creating residence information of the user */
export type CreateResidenceInfoInput = {
  /** Primary address line of the residence */
  addressLine1: Scalars['String']['input'];
  /** Secondary address line of the residence */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City of the residence */
  city: Scalars['String']['input'];
  /** month/year started residing at the residence */
  monthResiding: Scalars['String']['input'];
  /** Ownership status of the residence */
  ownedBy: Scalars['String']['input'];
  /** Unique identifier for the personal information */
  personalInfoId: Scalars['Int']['input'];
  /** State of the residence */
  userState: Scalars['String']['input'];
  /** Zip code of the residence */
  zipCode: Scalars['String']['input'];
};

/** Information about a dealer location. */
export type DealerLocation = {
  __typename?: 'DealerLocation';
  /** Primary address line of the dealer location */
  addressLine1: Scalars['String']['output'];
  /** Secondary address line of the dealer location */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** City where the dealer is located */
  city: Scalars['String']['output'];
  /** Unique identifier for the dealer */
  dealerId: Scalars['String']['output'];
  /** Name of the dealer */
  dealerName: Scalars['String']['output'];
  /** Distance to the dealer location */
  distance: Scalars['String']['output'];
  /** Latitude coordinate of the dealer location */
  latitude: Scalars['String']['output'];
  /** Longitude coordinate of the dealer location */
  longitude: Scalars['String']['output'];
  /** Phone number of the dealer */
  phone?: Scalars['String']['output'];
  /** Score of the dealer location */
  score: Scalars['String']['output'];
  /** State where the dealer is located */
  state: Scalars['String']['output'];
  /** Zip code of the dealer location */
  zip: Scalars['String']['output'];
};

/** The different types of app metrics */
export enum EMetricsTypes {
  Allt = 'allt',
  Atlt = 'atlt',
}

/** Entity representing the income details of a user */
export type Income = {
  __typename?: 'Income';
  /** Bi-weekly pay of the user */
  biWeeklyPay: Scalars['String']['output'];
  /** Name of the employer */
  employerName?: Maybe<Scalars['String']['output']>;
  /** Phone number of the employer */
  employerPhone?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the employment information */
  employmentInfoId: Scalars['Int']['output'];
  /** Order of employments for the user */
  employmentOrder: Scalars['Int']['output'];
  /** Hire date of the user */
  hireDate: Scalars['String']['output'];
  /** Type of income */
  incomeType: Scalars['String']['output'];
  /** Unique identifier for the personal information */
  personalInfoId: Scalars['Int']['output'];
};

/** Input model for the income details of the user */
export type IncomeInput = {
  /** Bi-weekly pay of the user */
  biWeeklyPay: Scalars['String']['input'];
  /** Name of the employer */
  employerName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the employer */
  employerPhone?: InputMaybe<Scalars['String']['input']>;
  /** Order of employments for the user */
  employmentOrder: Scalars['Int']['input'];
  /** Hire date of the user */
  hireDate: Scalars['String']['input'];
  /** Type of income */
  incomeType: Scalars['String']['input'];
};

/** Input model for the long form application process */
export type LongFormInfoInput = {
  /** Account information of the user */
  account: AccountInput;
  /** Indicates if the user has given consent for credit authorization */
  creditauthConsent: Scalars['Boolean']['input'];
  /** List of income details of the user */
  income: Array<IncomeInput>;
  /** Personal information of the user */
  personal: PersonalInfoInput;
  /** Indicates if the user has given consent for phone and email communication */
  phoneEmailConsent: Scalars['Boolean']['input'];
  /** Residence information of the user */
  residence: ResidenceInfoInput;
  /** Social Security Number of the user */
  ssn: Scalars['String']['input'];
};

/** Response model for the long form prequalification process */
export type LongFormPrequalResponse = {
  __typename?: 'LongFormPrequalResponse';
  /** List of dealer locations associated with the application */
  dealerLocations?: Maybe<Array<DealerLocation>>;
  /** Reason for failure if the prequalification process fails */
  failureReason: Scalars['String']['output'];
  /** Indicates if the user has a frozen credit bureau */
  frozenBureau: Scalars['Boolean']['output'];
  /** Indicates if the user has provided an invalid Social Security Number */
  invalidSsn: Scalars['Boolean']['output'];
  /** Maximum finance amount allowed */
  maxFinanceAmount?: Maybe<Scalars['Int']['output']>;
  /** Maximum monthly payment allowed */
  maxMonthlyPayment?: Maybe<Scalars['Int']['output']>;
  /** Minimum down payment required */
  minimumDownPayment?: Maybe<Scalars['Int']['output']>;
  /** Indicates if the user has an open loan */
  openLoan: Scalars['Boolean']['output'];
  /** Unique identifier for the portal application */
  portalApplicationId?: Maybe<Scalars['Int']['output']>;
  /** Status of the prequalification process */
  status: Scalars['String']['output'];
};

/** Input model for metrics data */
export type MetricsInput = {
  /** Type of the metric */
  metricsType: EMetricsTypes;
  /** Value of the metric */
  value: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Collects metrics data and logs the information. */
  collectMetrics: Scalars['Boolean']['output'];
  /** Creates an abandon prequalified email and submits the form to Eloqua. */
  createAbandonEmail: Scalars['Boolean']['output'];
  /** Creates a new list of bank account types for a user */
  createAccount: Account;
  /** Creates a new list of potential dealer leads for an application */
  createApplicationCaps: Scalars['Boolean']['output'];
  /** Creates new dealer locations based on the provided arguments */
  createDealerLocations: Array<DealerLocation>;
  /** Creates a new identification consent for an application */
  createIdentificationConsent: Scalars['Boolean']['output'];
  /** Creates a new list of incomes for a user */
  createIncome: Array<Income>;
  /** Creates personal information for a user along with generating the required application first */
  createPersonalInfoWithApplication: PersonalInfo;
  /** Creates a new residence information record for the user */
  createResidenceInfo: ResidenceInfo;
  /** Deletes an incomes for a user */
  deleteIncome: Income;
  /** Extends the JWT access token if valid, otherwise returns an error. */
  extendToken: Scalars['Boolean']['output'];
  /** Re-submit a long form application */
  reSubmitLongFormApplication: LongFormPrequalResponse;
  /** Final submit for the multi-step form for prequalification */
  submitApplication: PrequalificationResponse;
  /** Submit the CAPS lead for prequalification */
  submitCapsLead: Scalars['Boolean']['output'];
  /** Submit a long form application */
  submitLongFormApplication: LongFormPrequalResponse;
  /** Updates a list of bank account types for a user */
  updateAccount: Account;
  /** Updates the list of incomes for a user */
  updateIncome: Array<Income>;
  updateIndex: Scalars['Boolean']['output'];
  /** Updates the personal information of a user */
  updatePersonalInfo: PersonalInfo;
  /** Updates an existing residence information record for the user */
  updateResidenceInfo: ResidenceInfo;
};

export type MutationCollectMetricsArgs = {
  metrics: MetricsInput;
};

export type MutationCreateAbandonEmailArgs = {
  createAbandonEmailInput: CreateAbandonEmailInput;
};

export type MutationCreateAccountArgs = {
  createAccountInput: CreateAccountInput;
};

export type MutationCreateApplicationCapsArgs = {
  createApplicationCapsInput: Array<CreateApplicationCapsInput>;
};

export type MutationCreateDealerLocationsArgs = {
  city: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  shortAddressLine1: Scalars['String']['input'];
  shortAddressLine2?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type MutationCreateIdentificationConsentArgs = {
  agreementConsent: Scalars['Boolean']['input'];
};

export type MutationCreateIncomeArgs = {
  createIncomeInput: Array<CreateIncomeInput>;
};

export type MutationCreatePersonalInfoWithApplicationArgs = {
  createPersonalInfoInput: CreatePersonalInfoInput;
};

export type MutationCreateResidenceInfoArgs = {
  createResidenceInfoInput: CreateResidenceInfoInput;
};

export type MutationDeleteIncomeArgs = {
  employmentInfoId: Scalars['Int']['input'];
  personalInfoId: Scalars['Int']['input'];
};

export type MutationExtendTokenArgs = {
  accessToken: Scalars['String']['input'];
};

export type MutationReSubmitLongFormApplicationArgs = {
  longFormInfoInput: LongFormInfoInput;
};

export type MutationSubmitApplicationArgs = {
  submitApplicationInput: SubmitApplicationInput;
};

export type MutationSubmitCapsLeadArgs = {
  agreementConsent: Scalars['Boolean']['input'];
};

export type MutationSubmitLongFormApplicationArgs = {
  longFormInfoInput: LongFormInfoInput;
};

export type MutationUpdateAccountArgs = {
  updateAccountInput: UpdateAccountInput;
};

export type MutationUpdateIncomeArgs = {
  updateIncomeInput: Array<UpdateIncomeInput>;
};

export type MutationUpdatePersonalInfoArgs = {
  updatePersonalInfoInput: UpdatePersonalInfoInput;
};

export type MutationUpdateResidenceInfoArgs = {
  updateResidenceInfoInput: UpdateResidenceInfoInput;
};

/** Customer personal info. */
export type PersonalInfo = {
  __typename?: 'PersonalInfo';
  /** Unique identifier for the application */
  applicationId: Scalars['Int']['output'];
  /** Date of birth of the user */
  dateOfBirth: Scalars['String']['output'];
  /** Currently not being used */
  driver?: Maybe<Scalars['Int']['output']>;
  /** Email address of the user */
  email: Scalars['String']['output'];
  /** First name of the user */
  firstName: Scalars['String']['output'];
  /** Last name of the user */
  lastName: Scalars['String']['output'];
  /** Unique identifier for the personal information */
  personalInfoId: Scalars['Int']['output'];
  /** Phone number of the user */
  phone: Scalars['String']['output'];
  /** Unique ID corresponding to the user's social security number data */
  ssnid?: Maybe<Scalars['Int']['output']>;
};

/** Input model for the personal information of the user */
export type PersonalInfoInput = {
  /** Application details associated with the personal information */
  application: ApplicationInput;
  /** Date of birth of the user */
  dateOfBirth: Scalars['String']['input'];
  /** Currently not being used */
  driver?: InputMaybe<Scalars['Int']['input']>;
  /** Email address of the user */
  email: Scalars['String']['input'];
  /** First name of the user */
  firstName: Scalars['String']['input'];
  /** Last name of the user */
  lastName: Scalars['String']['input'];
  /** Phone number of the user */
  phone: Scalars['String']['input'];
};

/** Response object for the prequalification process */
export type PrequalificationResponse = {
  __typename?: 'PrequalificationResponse';
  /** Reason for preuqalification failure */
  failureReason: Scalars['String']['output'];
  /** Indicates if the credit bureau is frozen */
  frozenBureau: Scalars['Boolean']['output'];
  /** Indicates if the provided SSN is invalid */
  invalidSsn: Scalars['Boolean']['output'];
  /** Maximum finance amount allowed */
  maxFinanceAmount?: Maybe<Scalars['Int']['output']>;
  /** Maximum monthly payment allowed */
  maxMonthlyPayment?: Maybe<Scalars['Int']['output']>;
  /** Minimum down payment required */
  minimumDownPayment?: Maybe<Scalars['Int']['output']>;
  /** Indicates if there is an open loan */
  openLoan: Scalars['Boolean']['output'];
  /** Status of the prequalification process */
  status: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Retrieves the list of accounts for a single user */
  account: Account;
  /** Retrieves the list of incomes for a user */
  allRelatedIncomes: Array<Income>;
  /** Fetches a list of dealer locations based on the provided arguments */
  dealerLocations: Array<DealerLocation>;
  /** Retrieves the consent text for a given consent type */
  getConsentByType: ConsentTextInfo;
  /** Retrieves the consent texts for a given list of consent types */
  getConsentsByTypes: Array<ConsentTextInfo>;
  getToken: Scalars['String']['output'];
  /** Retrieves the personal information of a user by their unique identifier */
  personalInfo: PersonalInfo;
  /** Fetches a residence information record by its unique identifier */
  residenceInfo: ResidenceInfo;
  search: SearchPage;
  /** Verifies the status of a given zip code */
  zipCodeVerification: ZipCodeVerification;
};

export type QueryAccountArgs = {
  bankingInfoId: Scalars['Int']['input'];
  personalInfoId: Scalars['Int']['input'];
};

export type QueryAllRelatedIncomesArgs = {
  personalInfoId: Scalars['Int']['input'];
};

export type QueryDealerLocationsArgs = {
  city: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  shortAddressLine1: Scalars['String']['input'];
  shortAddressLine2?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type QueryGetConsentByTypeArgs = {
  consentType: Scalars['String']['input'];
};

export type QueryGetConsentsByTypesArgs = {
  consentTypes: Array<Scalars['String']['input']>;
};

export type QueryGetTokenArgs = {
  applicationId: Scalars['String']['input'];
};

export type QueryPersonalInfoArgs = {
  personalInfoId: Scalars['Int']['input'];
};

export type QueryResidenceInfoArgs = {
  personalInfoId: Scalars['Int']['input'];
  residenceInfoId: Scalars['Int']['input'];
};

export type QuerySearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};

export type QueryZipCodeVerificationArgs = {
  zipCode: Scalars['String']['input'];
};

/** Customer residence info. */
export type ResidenceInfo = {
  __typename?: 'ResidenceInfo';
  /** Primary address line of the residence */
  addressLine1: Scalars['String']['output'];
  /** Secondary address line of the residence */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** City of the residence */
  city: Scalars['String']['output'];
  /** month/year started residing at the residence */
  monthResiding: Scalars['String']['output'];
  /** Ownership status of the residence */
  ownedBy: Scalars['String']['output'];
  /** Unique identifier for the personal information */
  personalInfoId: Scalars['Int']['output'];
  /** Unique identifier for the residence information */
  residenceInfoId: Scalars['Int']['output'];
  /** State of the residence */
  userState: Scalars['String']['output'];
  /** Zip code of the residence */
  zipCode: Scalars['String']['output'];
};

/** Input model for the residence information of the user */
export type ResidenceInfoInput = {
  /** Primary address line of the residence */
  addressLine1: Scalars['String']['input'];
  /** Secondary address line of the residence */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City of the residence */
  city: Scalars['String']['input'];
  /** month/year started residing at the residence */
  monthResiding: Scalars['String']['input'];
  /** Ownership status of the residence */
  ownedBy: Scalars['String']['input'];
  /** State of the residence */
  userState: Scalars['String']['input'];
  /** Zip code of the residence */
  zipCode: Scalars['String']['input'];
};

export type SearchPage = {
  __typename?: 'SearchPage';
  count: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  records: Array<SearchPageRecord>;
};

export type SearchPageRecord = {
  __typename?: 'SearchPageRecord';
  content?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Model representing the required properties for the 'submitApplication' mutation */
export type SubmitApplicationInput = {
  /** Indicates if the user has given consent to the agreement */
  agreementConsent: Scalars['Boolean']['input'];
  /** Social Security Number of the user */
  ssn: Scalars['String']['input'];
};

/** Input model for updating account information of the user */
export type UpdateAccountInput = {
  /** Unique identifier for the banking information */
  bankingInfoId: Scalars['Int']['input'];
  /** List of bank account types for the user */
  bankingType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Unique identifier for the personal information */
  personalInfoId: Scalars['Int']['input'];
};

/** Model representing the required properties for the updateIncome mutation */
export type UpdateIncomeInput = {
  /** Bi-weekly pay of the user */
  biWeeklyPay?: InputMaybe<Scalars['String']['input']>;
  /** Name of the employer */
  employerName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the employer */
  employerPhone?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the employment information */
  employmentInfoId: Scalars['Int']['input'];
  /** Order of employments for the user */
  employmentOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Hire date of the user */
  hireDate?: InputMaybe<Scalars['String']['input']>;
  /** Type of income */
  incomeType?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the personal information */
  personalInfoId: Scalars['Int']['input'];
};

/** Input model for updating personal information of the user */
export type UpdatePersonalInfoInput = {
  /** Application details associated to the personal information */
  application?: InputMaybe<CreateApplicationInput>;
  /** Date of birth of the user */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** Currently not being used */
  driver?: InputMaybe<Scalars['Int']['input']>;
  /** Email address of the user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the user */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the user */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the personal information */
  personalInfoId: Scalars['Int']['input'];
  /** Phone number of the user */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID corresponding to the user's social security number data */
  ssnid?: InputMaybe<Scalars['Int']['input']>;
};

/** Input model for updating residence information of the user */
export type UpdateResidenceInfoInput = {
  /** Primary address line of the residence */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Secondary address line of the residence */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City of the residence */
  city?: InputMaybe<Scalars['String']['input']>;
  /** month/year started residing at the residence */
  monthResiding?: InputMaybe<Scalars['String']['input']>;
  /** Ownership status of the residence */
  ownedBy?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the personal information */
  personalInfoId: Scalars['Int']['input'];
  /** Unique identifier for the residence information */
  residenceInfoId: Scalars['Int']['input'];
  /** State of the residence */
  userState?: InputMaybe<Scalars['String']['input']>;
  /** Zip code of the residence */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** The different zip code verification statuses */
export enum ZipCodeStatus {
  InvalidTerritoryError = 'invalidTerritoryError',
  ValidZipCode = 'validZipCode',
  ZipCodeError = 'zipCodeError',
}

/** Entity representing the verification status of a zip code */
export type ZipCodeVerification = {
  __typename?: 'ZipCodeVerification';
  /** Indicates if the zip code is valid */
  zipCodeIsValid: Scalars['Boolean']['output'];
  /** The status of the zip code verification */
  zipCodeStatus: ZipCodeStatus;
};

export type ConsentTextInfoQueryVariables = Exact<{
  consentType: Scalars['String']['input'];
}>;

export type ConsentTextInfoQuery = {
  __typename?: 'Query';
  getConsentByType: {
    __typename?: 'ConsentTextInfo';
    consenttext: string;
    consenttextid: number;
    consentversion: string;
  };
};

export type CreateAbandonEmailMutationVariables = Exact<{
  createAbandonEmailInput: CreateAbandonEmailInput;
}>;

export type CreateAbandonEmailMutation = {
  __typename?: 'Mutation';
  createAbandonEmail: boolean;
};

export type ZipCodeVerificationQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
}>;

export type ZipCodeVerificationQuery = {
  __typename?: 'Query';
  zipCodeVerification: {
    __typename?: 'ZipCodeVerification';
    zipCodeIsValid: boolean;
    zipCodeStatus: ZipCodeStatus;
  };
};

export type ExtendTokenMutationVariables = Exact<{
  accessToken: Scalars['String']['input'];
}>;

export type ExtendTokenMutation = {
  __typename?: 'Mutation';
  extendToken: boolean;
};

export type CollectMetricsMutationVariables = Exact<{
  metrics: MetricsInput;
}>;

export type CollectMetricsMutation = {
  __typename?: 'Mutation';
  collectMetrics: boolean;
};

export type SubmitCapsLeadMutationVariables = Exact<{
  agreementConsent: Scalars['Boolean']['input'];
}>;

export type SubmitCapsLeadMutation = {
  __typename?: 'Mutation';
  submitCapsLead: boolean;
};

export type SubmitLongFormApplicationMutationVariables = Exact<{
  longFormInfoInput: LongFormInfoInput;
}>;

export type SubmitLongFormApplicationMutation = {
  __typename?: 'Mutation';
  submitLongFormApplication: {
    __typename?: 'LongFormPrequalResponse';
    failureReason: string;
    frozenBureau: boolean;
    invalidSsn: boolean;
    maxFinanceAmount?: number | null;
    maxMonthlyPayment?: number | null;
    minimumDownPayment?: number | null;
    openLoan: boolean;
    portalApplicationId?: number | null;
    status: string;
    dealerLocations?: Array<{
      __typename?: 'DealerLocation';
      addressLine1: string;
      addressLine2?: string | null;
      city: string;
      state: string;
      zip: string;
      dealerId: string;
      dealerName: string;
      phone: string;
    }> | null;
  };
};

export type ReSubmitLongFormApplicationMutationVariables = Exact<{
  longFormInfoInput: LongFormInfoInput;
}>;

export type ReSubmitLongFormApplicationMutation = {
  __typename?: 'Mutation';
  reSubmitLongFormApplication: {
    __typename?: 'LongFormPrequalResponse';
    failureReason: string;
    frozenBureau: boolean;
    invalidSsn: boolean;
    maxFinanceAmount?: number | null;
    maxMonthlyPayment?: number | null;
    minimumDownPayment?: number | null;
    openLoan: boolean;
    portalApplicationId?: number | null;
    status: string;
    dealerLocations?: Array<{
      __typename?: 'DealerLocation';
      addressLine1: string;
      addressLine2?: string | null;
      city: string;
      state: string;
      zip: string;
      dealerId: string;
      dealerName: string;
      phone: string;
    }> | null;
  };
};

export const ConsentTextInfoDocument = /*#__PURE__*/ gql`
  query ConsentTextInfo($consentType: String!) {
    getConsentByType(consentType: $consentType) {
      consenttext
      consenttextid
      consentversion
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ConsentTextInfoQueryService extends Apollo.Query<
  ConsentTextInfoQuery,
  ConsentTextInfoQueryVariables
> {
  override document = ConsentTextInfoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateAbandonEmailDocument = /*#__PURE__*/ gql`
  mutation CreateAbandonEmail(
    $createAbandonEmailInput: CreateAbandonEmailInput!
  ) {
    createAbandonEmail(createAbandonEmailInput: $createAbandonEmailInput)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateAbandonEmailMutationService extends Apollo.Mutation<
  CreateAbandonEmailMutation,
  CreateAbandonEmailMutationVariables
> {
  override document = CreateAbandonEmailDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ZipCodeVerificationDocument = /*#__PURE__*/ gql`
  query ZipCodeVerification($zipCode: String!) {
    zipCodeVerification(zipCode: $zipCode) {
      zipCodeIsValid
      zipCodeStatus
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ZipCodeVerificationQueryService extends Apollo.Query<
  ZipCodeVerificationQuery,
  ZipCodeVerificationQueryVariables
> {
  override document = ZipCodeVerificationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExtendTokenDocument = /*#__PURE__*/ gql`
  mutation ExtendToken($accessToken: String!) {
    extendToken(accessToken: $accessToken)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ExtendTokenMutationService extends Apollo.Mutation<
  ExtendTokenMutation,
  ExtendTokenMutationVariables
> {
  override document = ExtendTokenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CollectMetricsDocument = /*#__PURE__*/ gql`
  mutation CollectMetrics($metrics: MetricsInput!) {
    collectMetrics(metrics: $metrics)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CollectMetricsMutationService extends Apollo.Mutation<
  CollectMetricsMutation,
  CollectMetricsMutationVariables
> {
  override document = CollectMetricsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SubmitCapsLeadDocument = /*#__PURE__*/ gql`
  mutation SubmitCapsLead($agreementConsent: Boolean!) {
    submitCapsLead(agreementConsent: $agreementConsent)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SubmitCapsLeadMutationService extends Apollo.Mutation<
  SubmitCapsLeadMutation,
  SubmitCapsLeadMutationVariables
> {
  override document = SubmitCapsLeadDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SubmitLongFormApplicationDocument = /*#__PURE__*/ gql`
  mutation SubmitLongFormApplication($longFormInfoInput: LongFormInfoInput!) {
    submitLongFormApplication(longFormInfoInput: $longFormInfoInput) {
      failureReason
      frozenBureau
      invalidSsn
      maxFinanceAmount
      maxMonthlyPayment
      minimumDownPayment
      openLoan
      portalApplicationId
      status
      dealerLocations {
        addressLine1
        addressLine2
        city
        state
        zip
        dealerId
        dealerName
        phone
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SubmitLongFormApplicationMutationService extends Apollo.Mutation<
  SubmitLongFormApplicationMutation,
  SubmitLongFormApplicationMutationVariables
> {
  override document = SubmitLongFormApplicationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ReSubmitLongFormApplicationDocument = /*#__PURE__*/ gql`
  mutation ReSubmitLongFormApplication($longFormInfoInput: LongFormInfoInput!) {
    reSubmitLongFormApplication(longFormInfoInput: $longFormInfoInput) {
      failureReason
      frozenBureau
      invalidSsn
      maxFinanceAmount
      maxMonthlyPayment
      minimumDownPayment
      openLoan
      portalApplicationId
      status
      dealerLocations {
        addressLine1
        addressLine2
        city
        state
        zip
        dealerId
        dealerName
        phone
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ReSubmitLongFormApplicationMutationService extends Apollo.Mutation<
  ReSubmitLongFormApplicationMutation,
  ReSubmitLongFormApplicationMutationVariables
> {
  override document = ReSubmitLongFormApplicationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
